import { AutogenLayoutUomExcludedExceptionSlideout } from "./autogen/AutogenLayoutUomExcludedExceptionSlideout";

export class UomExcludedExceptionSlideout extends AutogenLayoutUomExcludedExceptionSlideout {

}
